<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-img
          :src="require('@/assets/banner-finantare_alt.png')"
          class="mx-auto"
          contain
          max-height="150px"
        ></v-img>
      </v-col>
    </v-row>

    <v-card class="pa-md-4 mx-auto" max-width="900px">
      <v-card-title>
        <h1 class="text-h4 text-center mb-3">Cont dezactivat</h1>
      </v-card-title>
      <v-card-text>
        <v-alert type="warning" border="left" prominent text>
          Contul dumneavoastra a fost dezactivat.
          Va rugam sa folositi <router-link :to="{ path: '/Contact' }" class="grey--text">formularul de contact</router-link> pentru a lua legatura cu un administrator daca doriti reactivarea contului.
        </v-alert>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "deactivated"
};
</script>
